<template>
  <div>
    <h1 class="page-header">Company Profiles</h1>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-6">
            <ts-button color="info" outline @click="$router.push({ name: 'company-create' })">
              Add New
            </ts-button>
          </div>
          <div class="col-sm-6 d-flex justify-content-end">
            <ts-input v-model="search" placeholder="Search" style="width: 300px;" />
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template slot-scope="{ record }">
            <td>{{ record.prefix_code }}</td>
            <td class="kh-font">{{ record.company_name_kh }}</td>
            <td>{{ record.company_name_en }}</td>
            <td>{{ record.company_phone }}</td>
            <td>{{ record.company_email }}</td>
            <td>{{ record.company_website }}</td>
            <td>{{ record.company_address }}</td>
            <td class="text-center">
              <router-link :to="{ name: 'company-edit', params: { id: record.company_id } }" title="edit" class="mr-2">
                <i class="fas fa-edit"></i>
              </router-link>

              <a href="#" title="delete" class="text-danger" @click="destroy(record.company_id)">
                <i class="fas fa-trash"></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData"> </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'company',
  data() {
    return {
      loading: false,
      columns: [
        { name: 'prefix code' },
        { name: 'company name kh' },
        { name: 'company name en' },
        { name: 'phone number' },
        { name: 'email' },
        { name: 'website' },
        { name: 'addresss' },
        { name: 'actions', style: 'text-align:center' }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('administration/company', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.administration.company.search
      },
      set(newValue) {
        this.$store.commit('administration/company/SET_SEARCH', newValue)
        this.$store.commit('administration/company/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('administration/company/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },

    async destroy(id) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        this.$store
          .dispatch('administration/company/destroyCompany', id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'company-create') {
      this.$store.commit('administration/company/RESET_STATE')
    }
    next()
  }
}
</script>
